module.exports = typeof templateVars !== 'undefined' && typeof testComponentName !== 'undefined' && testComponentName === 'page-nav/buttons' && templateVars.config ?
				templateVars.config :
				{
	"titleParam": "shortTitle",
	"customTooltip": true,
	"hideUpBtn": false,
	"scrollTopValue": 200,
	"deactivateBtn": "deactivate"
};